/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_EmptyInputs */



/**
* | output |
* | --- |
* | "No usable rows found — the file needs a header row and at least one row with a VEKN ID or email." |
*
* @param {Csv_Import_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_empty = /** @type {((inputs?: Csv_Import_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligne exploitable trouvée — le fichier doit contenir une ligne d'en-tête et au moins une ligne avec un VEKN ID ou un email.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron filas utilizables — el archivo necesita una fila de encabezado y al menos una fila con un ID VEKN o un correo electrónico.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma linha utilizável encontrada — o arquivo precisa de uma linha de cabeçalho e pelo menos uma linha com um ID VEKN ou um e-mail.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna riga utilizzabile trovata — il file deve avere una riga di intestazione e almeno una riga con un VEKN ID o un'email.")
	return /** @type {LocalizedString} */ ("No usable rows found — the file needs a header row and at least one row with a VEKN ID or email.")
});